/**
 * @generated SignedSource<<13d9e2eb5fb9ebbb619f555515edb6e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type Shell_viewer$data = {
  readonly employee: {
    readonly " $fragmentSpreads": FragmentRefs<"Sidebar_employee">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"Sidebar_viewer">;
  readonly " $fragmentType": "Shell_viewer";
};
export type Shell_viewer$key = {
  readonly " $data"?: Shell_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"Shell_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "Shell_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Sidebar_viewer"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Employee",
      "kind": "LinkedField",
      "name": "employee",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "Sidebar_employee"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ViewerUser",
  "abstractKey": null
};

(node as any).hash = "e18718d246e4a9e996b5be69ab2a179c";

export default node;
